import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { SlingLogDetailComponent } from 'src/app/pages/logs/sling-log/sling-log-detail/sling-log-detail.component';
import { SlingConfigService } from 'src/app/services/sling-config.service';

@Component({
  selector: 'app-sling-log-table',
  templateUrl: './sling-log-table.component.html',
  styleUrls: ['./sling-log-table.component.scss']
})
export class SlingLogTableComponent implements OnInit {

  @Input()
  slingLogs = [];

  @Input()
  isDialog = false;

  numberOfRows = 10;

  constructor(
    private slingConfigService: SlingConfigService,
        private dialog: DialogService,
  ) { }

  ngOnInit(): void {
    if ( !this.isDialog) {
      this.loadSlingConfig();
    }
  }

  showSlingLogDetail(slingLog: any): void {
    const ref = this.dialog.open(SlingLogDetailComponent, {
      header: 'Detalhes do Log',
      width: '70%',
      contentStyle: { 'max-height': '80vh', 'overflow': 'auto' },
      data: slingLog.changes,
    });

    ref.onClose.subscribe(() => {
    });
  }

  loadSlingConfig(): void {
    this.slingConfigService.getSlingConfig().subscribe(
      (data) => {
        const slingConfig = data[0];
        if (slingConfig != null) {
          this.numberOfRows = slingConfig.numberOfRecordsPerPage;
        } else {
          this.numberOfRows = 10;
        }
      },
      (error) => null);
  }

}
